<script lang="ts">
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	type JsonValue = any;

	let {
		value,
		depth = 0,
		key = null
	}: { value: JsonValue; depth?: number; key?: string | null } = $props();

	let collapsed = $state(depth > 1);

	const type = $derived.by(() => {
		if (value === null) {
			return 'null';
		}
		if (Array.isArray(value)) {
			return 'array';
		}
		return typeof value;
	});

	const isExpandable = $derived(type === 'object' || type === 'array');

	const entries = $derived.by(() => {
		if (type === 'array') {
			return (value as JsonValue[]).map((v, i) => [String(i), v] as [string, JsonValue]);
		}
		if (type === 'object') {
			return Object.entries(value as Record<string, JsonValue>);
		}
		return [];
	});

	const preview = $derived.by(() => {
		if (type === 'array') {
			return `[${(value as JsonValue[]).length}]`;
		}
		if (type === 'object') {
			const keys = Object.keys(value as object);
			return `{${keys.slice(0, 3).join(', ')}${keys.length > 3 ? '…' : ''}}`;
		}
		return '';
	});

	function valueColor(t: string) {
		switch (t) {
			case 'string':
				return 'text-emerald-400';
			case 'number':
				return 'text-blue-400';
			case 'boolean':
				return 'text-purple-400';
			case 'null':
				return 'text-gray-500';
			default:
				return 'text-gray-300';
		}
	}
</script>

<span class="font-mono text-xs leading-5">
	{#if key !== null}
		<span class="text-yellow-300/80">{key}</span>
		<span class="text-gray-600">: </span>
	{/if}

	{#if isExpandable}
		<button
			onclick={() => (collapsed = !collapsed)}
			class="inline-flex items-center gap-0.5 hover:text-white transition-colors text-gray-400"
		>
			<span class="w-3 text-center text-gray-600 text-[10px]">{collapsed ? '▶' : '▼'}</span>
			{#if collapsed}
				<span class="text-gray-500 italic">{preview}</span>
			{:else}
				<span class="text-gray-600">
					{#if type === 'array'}[{:else}{'{'}}{/if}
				</span>
			{/if}
		</button>

		{#if !collapsed}
			<div class="ml-4 border-l border-white/6 pl-2">
				{#each entries as [k, v] (k)}
					<div>
						<svelte:self value={v} depth={depth + 1} key={k} />
					</div>
				{/each}
			</div>
			<span class="text-gray-600">
				{#if type === 'array'}]{:else}{'}'}{/if}
			</span>
		{/if}
	{:else}
		<span class={valueColor(type)}>
			{#if type === 'string'}"{value}"{:else}{String(value)}{/if}
		</span>
	{/if}
</span>
